import { Component, ChangeDetectionStrategy} from "@angular/core";
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { AltSecDropDownComponent } from "./com-alt-securities-dropdown.component";

@Component({ standalone: false,
    selector: 'alt-sec-edit-dropdown-cell',
    templateUrl: './com-alt-securities-dropdown.component.html',
    changeDetection: ChangeDetectionStrategy.Eager
  })
export class AltSecDropDownCellEditor extends AltSecDropDownComponent implements ICellEditorAngularComp  {

    params: any;

    getValue() {
        return this.altSecuritySymbol;
    }

    isPopup(): boolean {
        return true;
    }

    agInit(params: any): void {
        this.params = params;
        this.populateAltSecurity(params);
        this.populateSecuritiesDropdown(params);
        this.removeRestrictionSymbolFromDropDown();
        if (this.altSecuritySymbol === null || this.altSecuritySymbol === undefined) {
            this.params.context.componentParent.validateInput();
        }
    }

    public onSecurityChange() {
        this.pfRestriction.altSecuritySymbol = this.altSecuritySymbol.name;
        this.pfRestriction.altSecurityId = Number(this.altSecuritySymbol.id);
        this.params.context.componentParent.validateInput();
    }

  }
